<div class="modal-loading-background"></div>
<div class="loader">Loading...</div>